module.exports = __webpack_public_path__ + "static/media/DSP Ad Performance.f6c6b6f2.svg";